"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageStatusAndValue = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var mobx_react_1 = require("mobx-react");
var Types_1 = require("@CommonFrontendBackend/Projects/Types");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var Utils_1 = require("@CommonFrontendBackend/Projects/Utils");
var FormatCurrency_1 = require("@CommonFrontend/Utils/FormatCurrency");
var PageStatusIcon_1 = require("@CommonFrontend/Project/PageStatusIcon");
var Configuration_1 = require("@CommonFrontend/Styles/Configuration/Configuration");
var c = (0, BemBuilder_1.default)("page-status-value");
exports.PageStatusAndValue = (0, mobx_react_1.observer)(function (_a) {
    var pageQuoteTotalStore = _a.pageQuoteTotalStore, pageStatus = _a.pageStatus, manualPageValue = _a.manualPageValue, showManualPageValueModal = _a.showManualPageValueModal, openSharePopover = _a.openSharePopover;
    var _b = __read((0, react_1.useState)(false), 2), showTooltip = _b[0], setShowTooltip = _b[1];
    var currency = pageQuoteTotalStore.getCurrency(true);
    var currencyLocale = pageQuoteTotalStore.getCurrencyLocale();
    var pageStatusText = (0, Utils_1.pageStatusDisplayText)(pageStatus);
    var formattedQuoteValue = pageQuoteTotalStore.formattedQuoteValue, formattedPageValue = pageQuoteTotalStore.formattedPageValue;
    var buttonText = formattedPageValue !== null && formattedPageValue !== void 0 ? formattedPageValue : pageStatusText;
    var tooltipQuoteValue = formattedQuoteValue !== null && formattedQuoteValue !== void 0 ? formattedQuoteValue : "N/A";
    var formattedManualValue = manualPageValue.enabled
        ? (0, FormatCurrency_1.formatCurrency)(manualPageValue.value, currency, undefined, currencyLocale)
        : undefined;
    var tooltipManualValue = formattedManualValue !== null && formattedManualValue !== void 0 ? formattedManualValue : "N/A";
    var isAcceptedPage = pageStatus === Types_1.ProjectStatus.Accepted;
    var buttonContent = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(PageStatusIcon_1.PageStatusIcon, { status: pageStatus }),
        react_1.default.createElement(kaleidoscope_1.Text, { size: "m", strong: true }, buttonText)));
    return (react_1.default.createElement(kaleidoscope_1.Tooltip, { wrapTarget: true, show: isAcceptedPage ? undefined : showTooltip, size: kaleidoscope_1.TooltipSize.Large, content: react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: (0, classnames_1.default)(c("tooltip-heading"), "space-stack-xs") },
                react_1.default.createElement(PageStatusIcon_1.PageStatusIcon, { status: pageStatus }),
                react_1.default.createElement("div", { className: "text-context-label" }, pageStatusText)),
            react_1.default.createElement("div", { className: c("value-text") },
                "Quote value: ",
                tooltipQuoteValue),
            react_1.default.createElement("div", { className: c("value-text") },
                "Page value: ",
                tooltipManualValue)) }, isAcceptedPage ? (react_1.default.createElement("div", { className: (0, classnames_1.default)(c(), c("", "accepted")) }, buttonContent)) : (react_1.default.createElement(kaleidoscope_1.Layer, { offset: Configuration_1.navBarZIndex }, function () { return (react_1.default.createElement(kaleidoscope_1.OptionMenu, { autoStack: true, button: react_1.default.createElement(kaleidoscope_1.Button, { className: c(), type: kaleidoscope_1.ButtonType.Tertiary, onMouseEnter: function () { return setShowTooltip(true); }, onMouseLeave: function () { return setShowTooltip(false); }, onClick: function () { return setShowTooltip(false); } }, buttonContent) },
        react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { onClick: openSharePopover }, "Change status"),
        react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { onClick: showManualPageValueModal }, "Change value"))); }))));
});
